<xemex-dialog-shell [title]="'partnerships.addInstallationGroup.title' | translate">
  <div class="p-2">
    @if (isLoading()) {
      <p class="text-sm text-gray-500">{{ 'general.loading' | translate }}</p>
    } @else if (!groups().length) {
      <p class="text-sm text-gray-500">
        {{ 'partnerships.addInstallationGroup.noAvailable' | translate }}
      </p>
    } @else {
      <xemex-select-field
        [label]="'partnerships.addInstallationGroup.label' | translate"
        [required]="true"
        [invalid]="groupControl.invalid && groupControl.touched"
        [errorText]="
          'error.required'
            | translate: { field: ('partnerships.addInstallationGroup.label' | translate) }
        "
      >
        <mat-select
          [formControl]="groupControl"
          [placeholder]="'partnerships.addInstallationGroup.placeholder' | translate"
        >
          @for (group of groups(); track group.installationGroupOid) {
            <mat-option [value]="group.installationGroupOid">
              {{ group.name }}
            </mat-option>
          }
        </mat-select>
      </xemex-select-field>

      <div class="flex items-start gap-2 mt-3 text-xs text-gray-500">
        <mat-icon class="!text-base !w-4 !h-4 leading-4">info</mat-icon>
        <span>{{ 'partnerships.addInstallationGroup.hint' | translate }}</span>
      </div>
    }
  </div>

  <mat-dialog-actions actions>
    <xemex-filled-button type="button" [disabled]="!groups().length" (click)="onAdd()">
      {{ 'general.btnAdd' | translate }}
    </xemex-filled-button>
    <xemex-outlined-button type="button" (click)="onCancel()">
      {{ 'general.btnCancel' | translate }}
    </xemex-outlined-button>
  </mat-dialog-actions>
</xemex-dialog-shell>
